import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export default function LanguageSelect() {
  const { selectLanguage } = useLanguage();

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {/* Logo */}
        <div style={styles.logoContainer}>
          <img src="/logo.png" alt="FootParadise Comics" style={styles.logo} />
        </div>

        {/* Title with glass effect */}
        <div style={styles.glassCard}>
          <h1 style={styles.title}>Select Language</h1>
          <p style={styles.subtitle}>Seleccionar Idioma</p>
        </div>

        {/* Language Buttons */}
        <div style={styles.buttonsContainer}>
          <button
            onClick={() => selectLanguage('en')}
            style={styles.languageButton}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.boxShadow = '0 8px 32px rgba(255, 215, 0, 0.6)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = '0 6px 24px rgba(255, 215, 0, 0.4)';
            }}
          >
            <span style={styles.flag}>🇺🇸</span>
            <span style={styles.languageText}>English</span>
          </button>

          <button
            onClick={() => selectLanguage('es')}
            style={styles.languageButton}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.boxShadow = '0 8px 32px rgba(255, 215, 0, 0.6)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = '0 6px 24px rgba(255, 215, 0, 0.4)';
            }}
          >
            <span style={styles.flag}>🇪🇸</span>
            <span style={styles.languageText}>Español</span>
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundImage: 'url(/start-background.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px',
  },
  logoContainer: {
    marginBottom: '30px',
  },
  logo: {
    height: '80px',
    width: 'auto',
    objectFit: 'contain',
    filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))',
  },
  glassCard: {
    background: 'linear-gradient(165deg, rgba(58, 20, 104, 0.95) 0%, rgba(24, 8, 48, 0.97) 100%)',
    borderRadius: '20px',
    padding: '20px 36px',
    marginBottom: '36px',
    border: '3px solid #000',
    boxShadow: '0 6px 0 #000, 0 0 0 2px rgba(255, 45, 149, 0.9) inset',
    textAlign: 'center',
  },
  title: {
    fontSize: '26px',
    fontWeight: 'bold',
    color: '#FFD700',
    textAlign: 'center',
    margin: '0 0 8px 0',
    textShadow: '0 2px 8px rgba(0, 0, 0, 0.5), 0 0 20px rgba(255, 215, 0, 0.3)',
  },
  subtitle: {
    fontSize: '18px',
    color: '#fff',
    textAlign: 'center',
    margin: 0,
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
  },
  languageButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    padding: '20px 40px',
    background: 'linear-gradient(180deg, #fff27a 0%, #ffd400 50%, #ff9d00 100%)',
    border: '3px solid #000',
    borderRadius: '18px',
    cursor: 'pointer',
    boxShadow: '0 6px 0 #000, inset 0 2px 0 rgba(255, 255, 255, 0.55)',
    transition: 'transform 0.08s ease',
  },
  flag: {
    fontSize: '32px',
  },
  languageText: {
    fontSize: '22px',
    fontWeight: '900',
    fontStyle: 'italic',
    color: '#2a1200',
    textTransform: 'uppercase',
    letterSpacing: '2px',
  },
};
